import { Collection, Span, Text, TextInput, Checkbox, Select, SelectOption } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Field } from "../../Models/Description/Field";
import { Tab } from "../../Models/Product/Tab";
import { SvgEditor } from "./SvgEditor";
import { CollectionItemPrinter } from "./CollectionItemPrinter";
import { FormRow, FormPrinter } from "../../Pages/Product/InputsPrinter";


export class FieldEditor extends CollectionItemPrinter<Field>
{
    constructor(type: string, field: Field, allFields: Collection<Field>, tabs: Collection<Tab>, content: appendable[] = [])
    {
        super(field, allFields, [
            new Span(type).Class("badge"),
            new Text(field.Header).MarginLeft(8),
        ]);

        this.AddContent(
            new FormPrinter([
                new FormRow("Widoczny na stronie", new Checkbox(field.Visible)),
                new FormRow("Tab", new Select(field.Tab, tabs.Items.map(x => new SelectOption(x.Label.value, x.Id.value)))),
                new FormRow("Ikona", new SvgEditor(field.Icon)),
                new FormRow("Tytuł", new TextInput(field.Header).Placeholder("Tytuł sekcji")),
                new FormRow("Widoczny tytuł", new Checkbox(field.VisibleHeader)),
                new FormRow("Dodatkowe stylowanie", new TextInput(field.Style).Placeholder("Styl elementu (CSS)")),
            ]),
            ...content
        );
    }
}
